import React, { Fragment } from "react";
import Slider from "react-slick";

import { useRef } from "react";
import "./home.css";
import "../../../../css/newHome.css";
import { images } from "../../../../Shared";

import "./home.css";
// import Footer from "../../../layouts/Footer";
import { Link } from "react-router-dom";
const Home = () => {
	const myRef = useRef(null);

	const executeScroll = () => myRef.current.scrollIntoView();

	return (
		<Fragment>
			<div className="homepage">
				<div className="top-hero-section">
					<div className="top-hero-container">
						<div className="top-hero-image">
							<img src={images.heromain} alt="" />
						</div>
						<div className="top-hero-text">
							<h1> NITRO BOT NON-FUNGIBLE MINERS</h1>
							<p>
								Earn $NCASH while you sleep with NitroBots! Powered by the Nitro
								Network, owners of the NitroBots will be the first participants
								inside Nitro Network’s decentralized private communication
								network.
							</p>
							<p>
								NitroBots are Non-Fungible Miners (NFMs) that reward owners with
								$NCASH (Nitro's native utility token). Rewards are generated
								from Nitro's off-chain business partnerships. Owners receive
								$NCASH rewards every 30 minutes for as long as they own and
								stake their NitroBot.
							</p>

							<div className="div-static-image">
								<p>
									Choose your tier, mint your NFM, and let the robots do the
									rest.{" "}
								</p>
								<div className="grid-view-images">
									<Link to="/buy-nfm">
										<img src={images.hero1} alt="" />
									</Link>
									<Link to="/buy-nfm">
										<img src={images.hero2} alt="" />
									</Link>
									<Link to="/buy-nfm">
										<img src={images.hero3} alt="" />
									</Link>
									<Link to="/buy-nfm">
										<img src={images.hero4} alt="" />
									</Link>
									<Link to="/buy-nfm">
										<img src={images.hero5} alt="" />
									</Link>
									<Link to="/buy-nfm">
										<img src={images.hero6} alt="" />
									</Link>
								</div>

								<div className="text-right">
									{/* <Link to="/buy-nfm" className="buy-now-btn-home">
										Buy NFM
									</Link> */}
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Bot Section */}
				<div className="bot-section">
					<div className="first-bot-section">
						<img src={images.gallery1} alt="" id="bot-imae" />
						<img src={images.gallery2} alt="" id="bot-imae" />
						<img src={images.gallery3} alt="" id="bot-imae" />
						<img src={images.gallery4} alt="" id="bot-imae" />
						<img src={images.gallery5} alt="" id="bot-imae" />
						<img src={images.gallery6} alt="" id="bot-imae" />
						{/* <img src={images.bot18} alt="" id="bot-imae" /> */}

						{/* <img src={images.bot17} alt="" id="bot-image" />
            <img src={images.bot18} alt="" id="bot-image" />
            <img src={images.bot19} alt="" id="bot-image" />
            <img src={images.bot20} alt="" id="bot-image" />
            <img src={images.bot21} alt="" id="bot-image" />
            <img src={images.bot22} alt="" id="bot-image" />
            <img src={images.bot23} alt="" id="bot-image" />
            <img src={images.bot24} alt="" id="bot-image" />
            <img src={images.bot25} alt="" id="bot-image" /> */}
					</div>
					<div className="second-bot-section">
						{/* <img src={images.bot11} alt="" id="bot-imge" /> */}
						<img src={images.gallery7} alt="" id="bot-imge" />
						<img src={images.gallery8} alt="" id="bot-imge" />
						<img src={images.gallery9} alt="" id="bot-imge" />
						<img src={images.gallery10} alt="" id="bot-imge" />
						<img src={images.gallery11} alt="" id="bot-imge" />
						<img src={images.gallery12} alt="" id="bot-imge" />
						{/* <img src={images.bot17} alt="" id="bot-image" />
            <img src={images.bot18} alt="" id="bot-image" />
            <img src={images.bot19} alt="" id="bot-image" />
            <img src={images.bot20} alt="" id="bot-image" />
            <img src={images.bot21} alt="" id="bot-image" />
            <img src={images.bot22} alt="" id="bot-image" />
            <img src={images.bot23} alt="" id="bot-image" />
            <img src={images.bot24} alt="" id="bot-image" />
            <img src={images.bot25} alt="" id="bot-image" /> */}
					</div>
				</div>

				{/*  MULTI TIERD */}
				<div className="multi-tier">
					<h3>MULTI-TIERED NON-FUNGIBLE MINERS</h3>
					<div className="multi-tier-container">
						<div className="tier">
							<div className="tier-img">
								<img src={images.tier1} alt="" />
							</div>
							<div className="tier-text">
								<span>Tier 1</span>
								<h4>ICONIC NITRO BOTS</h4>

								<div>
									<span>
										<small>Rewards</small>
									</span>
									<p>95.69 NCASH per EPOCH</p>
								</div>

								<Link to="/buy-nfm" className="btn-view-detail">
									<span>View Details</span>
								</Link>
								{/* <a href="/buy-nfm" className="btn-view-detail">
                  <span>View Details</span>
                </a> */}
							</div>
						</div>
						<div className="tier">
							<div className="tier-img">
								<img src={images.tier2} alt="" />
							</div>
							<div className="tier-text">
								<span>Tier 2</span>
								<h4>PREMIUM NITRO BOTS</h4>

								<div>
									<span>
										<small>Rewards</small>
									</span>
									<p>80 NCASH per EPOCH</p>
								</div>
								<Link to="/buy-nfm" className="btn-view-detail">
									<span>View Details</span>
								</Link>
								{/* <a href="#" className="btn-view-detail">
                  <span>View Details</span>
                </a> */}
							</div>
						</div>
						<div className="tier">
							<div className="tier-img">
								<img src={images.tier3} alt="" />
							</div>
							<div className="tier-text">
								<span>Tier 3</span>
								<h4>TOP NITRO BOTS</h4>

								<div>
									<span>
										<small>Rewards</small>
									</span>
									<p>24.18 NCASH per EPOCH</p>
								</div>
								<Link to="/buy-nfm" className="btn-view-detail">
									<span>View Details</span>
								</Link>
								{/* <a href="#" className="btn-view-detail">
                  <span>View Details</span>
                </a> */}
							</div>
						</div>
					</div>
					<div className="ball-shade"></div>
				</div>

				{/* NFM Utility  */}
				<div className="nfm-utility">
					<h3>NFM UTILITY</h3>
					<div className="utility-container">
						<div className="utl-image">
							<img src={images.botUtility} alt="" />
						</div>
						<div className="utl-text">
							<p>
								Nitro Bot NFMs fund the Nitro Ion Nesters Miners that connect to
								and enable Nitro Network’s innovative decentralized private
								communication network. Each collectable NFM is a digital
								representation of an actual Nesting device deployed in a Nitro
								Network city and these NFMs are able to generate unlimited
								rewards in the form of $NCASH, Nitro Network’s Avalanche-based,
								native utility token.
							</p>
							<p>
								5000 Nesters are being deployed to dense urban areas such as New
								York City and Dubai. The initial deployment of Nesters will
								occur in dense urban areas of the United States and India in
								cities like New York City, Los Angeles, Mumbai and Delhi.
							</p>
							{/* <p>
                Infrastructure building is the next pahse of Nitro Network with
                5000 nestors deployed to dense urban hubs like NYC and Dubai.
              </p> */}
							{/* <p>
                After Nitro Nestors have been deployed, the Nitro team will
                start tracking experimental data on the network for the mall of
                Dubai and finding lost dog in NYC
              </p> */}

							{/* <a href="#." className="use-case-btn">
                Use Cases
              </a> */}
						</div>
					</div>
				</div>
				{/*  BIG BOTS */}
				<div className="big-bots">
					<h3>THE BIG BOTS</h3>
					<div className="big-bot-container">
						<div className="boot">
							<div>
								<img src={images.anoop} alt="" />
							</div>
							<p>Snoop-Anoop</p>
							<p>CEO</p>
						</div>
						<div className="boot">
							<div>
								<img src={images.pitti} alt="" />
							</div>
							<p>Pittibot</p>
							<p>CTO</p>
						</div>
						<div className="boot">
							<div>
								<img src={images.kall} alt="" />
							</div>
							<p>Kallmediamond </p>
							<p>COO</p>
						</div>
						<div className="boot">
							<div>
								<img src={images.thakur} alt="" />
							</div>
							<p>Jumpin Jack Thakur</p>
							<p>CPO</p>
						</div>
					</div>
					<div className="ball-shade"></div>
				</div>
			</div>
		</Fragment>
	);
};

export default Home;
